import { useQuery } from "@tanstack/react-query";
import { fetcher } from "@/lib/api";
import Seo from "@/components/Seo";
import CaseStudyRow from "@/components/CaseStudyRow";
import { Reveal } from "@/components/Reveal";
import Loader from "@/components/Loader";

export default function Work() {
  const { data: studies, isLoading } = useQuery({
    queryKey: ["case-studies"],
    queryFn: () => fetcher("/case-studies"),
  });

  return (
    <div data-testid="work-page" className="pt-36 lg:pt-44 pb-24 lg:pb-32">
      <Seo
        title="Work"
        description="Selected UX case studies by Nishant Gathwal — product design for HROne, Ixigo, and TheGeeksLab across HR, travel, and edtech."
        path="/work"
      />
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <p className="text-xs tracking-[0.2em] uppercase text-ash mb-5">Selected work</p>
          <h1 className="font-heading font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight text-cream text-balance max-w-3xl">
Case studies across travel, edtech & HR.
          </h1>
          <p className="mt-6 max-w-xl text-ash text-lg leading-relaxed">
            A closer look at the problems, the process, and the outcomes behind the products I've designed.
          </p>
        </Reveal>

        {isLoading ? (
          <Loader label="Loading work" />
        ) : (
          <div className="mt-12 border-b border-white/10">
            {(studies || []).map((s, i) => (
              <Reveal key={s.slug} delay={i * 0.05}>
                <CaseStudyRow study={s} index={String(i + 1).padStart(2, "0")} />
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
